import React, { useState, useEffect } from 'react';
import './HeroScreen.css';
import { FaTv } from 'react-icons/fa'; // FontAwesome Icons
import { MdAccessTime } from 'react-icons/md'; // Material Icons
import { BsCalendarDate } from 'react-icons/bs'; // Bootstrap Icons
import PreviewButton from './PreviewButton'; // ✅ Import PreviewButton

const HeroScreen = ({ apiUrl }) => {
    const [animeList, setAnimeList] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [previewOpen, setPreviewOpen] = useState(false); // ✅ State for preview modal

    // Fetch Anime Data
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(apiUrl);
                const data = await response.json();
                setAnimeList(data.data.slice(0, 10)); // Take top 10 results
            } catch (error) {
                console.error('Error fetching anime data:', error);
            }
        };
        fetchData();
    }, [apiUrl]);

    // Automatically rotate content every 5 seconds
    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % animeList.length);
        }, 5000); // 5 seconds
        return () => clearInterval(interval);
    }, [animeList.length]);

    // Guard Clause for Empty Data
    if (animeList.length === 0) return <p className="loading-text">Loading...</p>;

    const { title, title_english, synopsis, aired, duration, season, genres, images, mal_id } = animeList[currentIndex];

    // Get background image URL for current anime
    const backgroundImage = images?.jpg?.large_image_url || 'default-image-url.jpg'; // Set a default image if not available

    // Define dynamic background style with specific width and height for the image
    const backgroundStyle = {
        backgroundImage: `linear-gradient(to bottom, rgba(0.9, 0, 0, 0), rgba(0, 0, 0, 0.9)), url(${backgroundImage})`,
        backgroundSize: '100% 100%',  // Width: 150%, Height: 200% (example, adjust these values)
        backgroundPosition: 'center center',  // Align the image to the center of the container
        backgroundRepeat: 'no-repeat',  // Prevent repeating the image
        height: '70vh',  // Container height (this stays fixed)
        width: '100%'  // Container width (this stays fixed)
    };

    return (
        <div className="hero-screen" style={backgroundStyle}>
            <div className="hero-content">
                <h4 className="hero-spotlight">#3 Spotlight</h4>
                <h1 className="hero-title">{title_english || title}</h1>

                {/* Meta Info with Icons */}
                <p className="hero-meta">
                    <span><FaTv className="hero-icon" /> TV</span> •
                    <span><MdAccessTime className="hero-icon" /> {duration || 'N/A'}</span> •
                    <span><BsCalendarDate className="hero-icon" /> {aired?.string || 'N/A'}</span>
                </p>

                {/* Season and Genres */}
                <div className="hero-season-genres">
                    <p className="hero-season">
                        <strong>Season:</strong> {season || 'N/A'}
                    </p>
                    <div className="hero-genres">
                        {(Array.isArray(genres) ? genres : []).map((genre, index) => (
                            <span key={index} className="hero-genre">{genre.name || genre}</span>
                        ))}
                    </div>
                </div>

                <p className="hero-description">{synopsis.slice(0, 120)}...</p>

                {/* Preview Button Only */}
                <div className="hero-buttons">
                    <button className="hero-button-preview" onClick={() => setPreviewOpen(true)}>
                        <FaTv className="button-icon" /> Preview
                    </button>
                </div>
            </div>

            {/* ✅ Render PreviewButton as a modal when previewOpen is true */}
            {previewOpen && <PreviewButton animeId={mal_id} onClose={() => setPreviewOpen(false)} />}
        </div>
    );
};

export default HeroScreen;
